import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {ClientRouteParamType} from '@toolify/client/src/setup/router/enum/ClientRouteParamType'

export const RouteParamTypeToResourceTypeMap = new Map<ClientRouteParamType, ResourceType>([
  [ClientRouteParamType.DatabaseId, ResourceType.Database],
  [ClientRouteParamType.DatabaseViewId, ResourceType.DatabaseView],
  [ClientRouteParamType.DatabaseItemId, ResourceType.DatabaseItem],
  [ClientRouteParamType.DocumentId, ResourceType.Document],
  [ClientRouteParamType.SkillId, ResourceType.Skill],
  [ClientRouteParamType.AgentId, ResourceType.Agent],
  [ClientRouteParamType.ConversationId, ResourceType.Conversation],
  [ClientRouteParamType.DirectConversationId, ResourceType.DirectConversation],
  [ClientRouteParamType.DashboardId, ResourceType.Dashboard],
  [ClientRouteParamType.FolderId, ResourceType.Folder],
  [ClientRouteParamType.AutomationId, ResourceType.Automation],
  [ClientRouteParamType.CallRoomId, ResourceType.CallRoom],
])
